import { Stack, Typography } from '@mui/material';
import {
  CompaniesCarousel,
  MacBookWindow,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={
          <>
            Sleek front-end <br /> and powerful back-end <br /> to make your
            website pop
          </>
        }
        description={
          <>
            Build your <b>web product</b> with a team of experts
          </>
        }
        buttonLink="/contact"
        buttonText="Book a free consultation"
        gradient="aqua"
      />

      <Section width="normal">
        <Stack
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(7),
            marginTop: theme.spacing(6),
            textAlign: 'center',
            marginBottom: theme.spacing(16),
            [theme.breakpoints.down('md')]: {
              marginBottom: theme.spacing(15),
            },
            [theme.breakpoints.down('sm')]: {
              marginBottom: theme.spacing(9),
            },
          })}>
          <Typography
            sx={{
              color: (theme) => theme.palette.invertedContent?.PRIMARY,
            }}
            variant="strong_400">
            Rumble Fish is a web development company with vast knowledge of the
            latest dev trends and tools.
            <br />
            We’ve worked with global customers to help them bring their
            businesses to the next level. Join them!
          </Typography>
          <CompaniesCarousel />
        </Stack>
      </Section>
    </>
  );
};
